// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import api from './api'
import { post, get, put, postNo, deleteNo, parseTime, addDateRange, getWeekStartAndEnd, CONSTANTS } from './requests'
import axios from "axios";
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import * as echarts from 'echarts'
//引入main.scss文件
import "./style/main.css"
import global from './global'

import * as dayjs from 'dayjs'
import * as isLeapYear from 'dayjs/plugin/isLeapYear' // import plugin
import 'dayjs/locale/zh-cn' // import locale

dayjs.extend(isLeapYear) // use plugin
dayjs.locale('zh-cn') // use locale

//图片放大组件
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
import dataV from '@jiaminghi/data-view'
import '@/assets/styles/iconfont/iconfont.css'

Vue.use(dataV)

Vue.use(VueDirectiveImagePreviewer);

// 列表滚动组件
import scroll from 'vue-seamless-scroll';
import store from './store'
//3D字体
Vue.use(scroll)

//时间js插件
// dayjs().format()
// dayjs.locale('zh-cn')

Vue.prototype.api = api;
Vue.prototype.global = global;

Vue.prototype.post = post;
Vue.prototype.get = get;
Vue.prototype.put = put;
Vue.prototype.postNo = postNo;
Vue.prototype.deleteNo = deleteNo;
Vue.prototype.parseTime = parseTime;
Vue.prototype.addDateRange = addDateRange;
Vue.prototype.getWeekStartAndEnd = getWeekStartAndEnd;
Vue.prototype.CONSTANTS = CONSTANTS;

Vue.prototype.$axios = axios;
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.use(ElementUI);

/* 过滤器定义 */
import * as filters from './utils/filters'

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  render: h => h(App)
}).$mount('#app')

router.beforeEach((to, from, next) => {
  if (to.path === '/') {
    let token = localStorage.getItem('token');
    if (token) {
      next('/guide')
    } else {
      next();
    }
  } else {
    next();
  }
})



// WEBPACK FOOTER //
// ./src/main.js